import React from 'react';
import AuthForm from './AuthForm';

const LoginForm = (props) => (
  <AuthForm {...props} initialMode="login" />
);

export default LoginForm;